module.exports = __webpack_public_path__ + "img/mg-cnn.6273760e.png";